import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useLocalListQuery } from "@/hooks/useLocalListQuery";
import { DataTableFeatures } from "@/types/dataTableSettings";
import {
  DisplayContractorsPlannedHoursWizardResult,
  ReadContractorsPlannedHoursWizardResult,
} from "@/types/contractorsPlannedHoursWizard";
import { useMemo } from "react";

export const CONTRACTORS_PLANNED_HOURS_WIZARD_RESULTS_TABLE =
  "contractorsPlannedHoursWizardResults" as const;

const resultsTableFeatures: DataTableFeatures = {
  enableRowSelection: false,
  enableFilters: false,
  enableSorting: false,
};

export function useContractorsPlannedHoursWizardResultsQuery(
  results: ReadContractorsPlannedHoursWizardResult[],
) {
  const options =
    useCreateDataTableOptions<DisplayContractorsPlannedHoursWizardResult>(
      CONTRACTORS_PLANNED_HOURS_WIZARD_RESULTS_TABLE,
    );

  const rows = useMemo(
    () =>
      results.map((row, index) => ({
        id: `${index}-${row.period}`,
        period: row.period,
        hours: row.hours,
      })),
    [results],
  );

  const resultsKey = useMemo(() => JSON.stringify(results), [results]);

  const query = useLocalListQuery(
    [CONTRACTORS_PLANNED_HOURS_WIZARD_RESULTS_TABLE, resultsKey],
    rows,
    options,
  );

  const queryValue = useMemo(() => ({ query }), [query]);

  return {
    options,
    query,
    queryValue,
    resultsTableFeatures,
  };
}
